class EzFaqTeaserCarousel extends HTMLElement {
  constructor() {
    super();
    this.index = 0;
    this.autoplayTimer = null;
    this.touchStartX = 0;
  }

  connectedCallback() {
    this.track = this.querySelector('[data-track]');
    this.slides = this.querySelectorAll('[data-slide]');
    this.dots = this.querySelectorAll('[data-dot]');
    this.prevBtn = this.querySelector('[data-prev]');
    this.nextBtn = this.querySelector('[data-next]');
    this.viewport = this.querySelector('[data-viewport]');

    if (!this.track || this.slides.length === 0) return;

    this.slideCount = this.slides.length;
    this.autoplay = this.dataset.autoplay === 'true';
    this.autoplayMs = parseInt(this.dataset.autoplaySpeed, 10) || 6000;

    this.prevBtn?.addEventListener('click', () => this.go(-1));
    this.nextBtn?.addEventListener('click', () => this.go(1));
    this.dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const target = parseInt(dot.dataset.index, 10);
        if (!Number.isNaN(target)) this.show(target);
      });
    });

    this.viewport?.addEventListener(
      'touchstart',
      (event) => {
        this.touchStartX = event.changedTouches[0].screenX;
      },
      { passive: true }
    );

    this.viewport?.addEventListener(
      'touchend',
      (event) => {
        const delta = event.changedTouches[0].screenX - this.touchStartX;
        if (Math.abs(delta) < 40) return;
        this.go(delta < 0 ? 1 : -1);
      },
      { passive: true }
    );

    this.addEventListener('mouseenter', () => this.pauseAutoplay());
    this.addEventListener('mouseleave', () => this.startAutoplay());
    this.addEventListener('focusin', () => this.pauseAutoplay());
    this.addEventListener('focusout', () => this.startAutoplay());

    this.show(0);
    this.startAutoplay();
  }

  disconnectedCallback() {
    this.pauseAutoplay();
  }

  go(delta) {
    this.show((this.index + delta + this.slideCount) % this.slideCount);
  }

  show(nextIndex) {
    this.index = nextIndex;
    this.track.style.transform = `translateX(-${this.index * 100}%)`;

    this.slides.forEach((slide, i) => {
      slide.removeAttribute('hidden');
      slide.setAttribute('aria-hidden', i === this.index ? 'false' : 'true');
    });

    this.dots.forEach((dot, i) => {
      dot.setAttribute('aria-current', i === this.index ? 'true' : 'false');
    });

    if (this.prevBtn) this.prevBtn.disabled = this.slideCount <= 1;
    if (this.nextBtn) this.nextBtn.disabled = this.slideCount <= 1;
  }

  startAutoplay() {
    if (!this.autoplay || this.slideCount <= 1) return;
    this.pauseAutoplay();
    this.autoplayTimer = window.setInterval(() => this.go(1), this.autoplayMs);
  }

  pauseAutoplay() {
    if (this.autoplayTimer) {
      window.clearInterval(this.autoplayTimer);
      this.autoplayTimer = null;
    }
  }
}

if (!customElements.get('ez-faq-teaser-carousel')) {
  customElements.define('ez-faq-teaser-carousel', EzFaqTeaserCarousel);
}
